(() => {
  function sanitizePaginationForSEO() {
    const selectors = {
      pagination: {
        container: ".snize-pagination",
        link: "a"
      }
    };

    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    const observer = new MutationObserver((mutationsList, observer) => {
      const paginationElement = document.querySelector(selectors.pagination.container);

      if (paginationElement) {
        observer.disconnect();

        const links = [...paginationElement.querySelectorAll(selectors.pagination.link)];

        links.forEach((link) => {
          const url = new URL(link.href);

          if (url.searchParams.get("page") === "1") {
            url.searchParams.delete("page");
          }

          let cleanedUrl = url.origin + url.pathname;
          if (url.search) {
            cleanedUrl += url.search.replace(/\?&/, "?").replace(/\?$/, "");
          }

          link.href = cleanedUrl.toString();
        });
      }
    });

    observer.observe(targetNode, config);
  }

  document.addEventListener("Searchanise.Loaded", sanitizePaginationForSEO);
})();
